import { render, staticRenderFns } from "./ChevronsExpandIcon.vue?vue&type=template&id=5e05d275&"
import script from "./ChevronsExpandIcon.vue?vue&type=script&lang=js&"
export * from "./ChevronsExpandIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports